'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _n2 = require('../../../@Neptune/scripts/_n');

var _n3 = _interopRequireDefault(_n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizeScale = {

	init: function init() {
		SizeScale.load();
	},

	load: function load() {

		if (Neptune.passport.read('sizeScale')) {
			_n3.default.trigger(_n3.default.qs('[data-sizescale-label="' + Neptune.passport.read('sizeScale') + '"]'), 'click');
		} else {
			_n3.default.trigger(_n3.default.qs('[data-sizescale-label]'), 'click');
		}

		if (_n3.default.exists('[value="' + Neptune.passport.read('size') + '"]')) {
			_n3.default.qs('[value="' + Neptune.passport.read('size') + '"]').checked = true;

			if (_n3.default.exists('[data-size-scroll]')) _n3.default.qs('[data-size-scroll]').scrollTo(_n3.default.qs('[value="' + Neptune.passport.read('size') + '"] + label').getBoundingClientRect().left, 0);
		}
	}

};

window.SizeScale = SizeScale;

exports.default = SizeScale;